import { SvgIconType } from './svg.interface';

const Payment: SvgIconType = ({ width = 12, height = 10, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2H0V1.4375C0 0.919733 0.335786 0.5 0.75 0.5H11.25C11.6642 0.5 12 0.919733 12 1.4375V2ZM12 3.875V8.75C12 9.16421 11.6642 9.5 11.25 9.5H0.75C0.335786 9.5 0 9.16421 0 8.75V3.875H12ZM3 6.5C2.58579 6.5 2.25 6.83579 2.25 7.25C2.25 7.66421 2.58579 8 3 8H3.75C4.16421 8 4.5 7.66421 4.5 7.25C4.5 6.83579 4.16421 6.5 3.75 6.5H3Z"
      fill="#3AA5DC"
    />
  </svg>
);

export default Payment;
